import "./PackageUsageBar.scss";

import React from "react";

export default function PackageUsageBar({
  label = "Serviço",
  total = 0,
  remaining = 0,
}) {
  const safeTotal = Number(total) || 0;
  const safeRemaining = Number(remaining) || 0;

  const used = Math.max(safeTotal - safeRemaining, 0);
  const percent = safeTotal > 0 ? Math.min((used / safeTotal) * 100, 100) : 0;

  return (
    <div className="package-usage">
      <div className="package-usage__header">
        <span>{label}</span>

        <span className="package-usage__numbers">
          {used} / {safeTotal}
        </span>
      </div>

      <div className="package-usage__bar">
        <div
          className="package-usage__progress"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}